// Recent.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function Recent() {
    return (
        <PageLayout title="Recent" subtitle="Recent overview">
            <div className="container flex col box-container">
                {/* <div className="box">Recent</div> */}
            </div>
        </PageLayout>   
    );
}

export default Recent;
